import Section from "../../layout/Section/Section";
import { whyChooseUs } from "../../../data/whyChooseUs";
import styles from "./WhyChooseUs.module.css";

function WhyIcon({ name }) {
  const icons = {
    code: <><path d="m8 6-6 6 6 6M16 6l6 6-6 6" /></>,
    map: <><path d="m3 6 5-3 8 3 5-3v15l-5 3-8-3-5 3V6Z" /><path d="M8 3v15M16 6v15" /></>,
    "all-in-one": <><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></>,
    billing: <><path d="M6 2h9l4 4v16H6z" /><path d="M9 9h6M9 13h6M9 17h4" /></>,
    phone: <><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" /></>,
    hosting: <><rect x="3" y="3" width="18" height="7" rx="2" /><rect x="3" y="14" width="18" height="7" rx="2" /><path d="M7 6.5h.01M7 17.5h.01M12 6.5h5M12 17.5h5" /></>,
  };
  return <svg viewBox="0 0 24 24" aria-hidden="true">{icons[name]}</svg>;
}

const platformItems = [
  { icon: "code", label: "Website" },
  { icon: "map", label: "Maps" },
  { icon: "billing", label: "Business tools" },
  { icon: "hosting", label: "Hosting" },
];

export default function WhyChooseUs() {
  const featured = whyChooseUs.find((item) => item.featured);
  const items = whyChooseUs.filter((item) => !item.featured);
  return (
    <Section id="why" eyebrow="The Visible Online difference" title="Built with care. Built for your business." subtitle="The expertise you need, with the personal attention your business deserves." bg="white">
      <div className={styles.layout}>
        {featured && (
          <article className={styles.featured}>
            <span className={styles.featuredEyebrow}>One partner. Everything connected.</span>
            <div className={styles.platform} aria-hidden="true">
              <div className={styles.platformCenter}><WhyIcon name="all-in-one" /><span>Your business</span></div>
              <div className={styles.platformGrid}>
                {platformItems.map((item) => <div className={styles.platformItem} key={item.label}><WhyIcon name={item.icon} /><span>{item.label}</span></div>)}
              </div>
            </div>
            <h3 className={styles.featuredTitle}>{featured.title}</h3>
            <p className={styles.featuredText}>{featured.text}</p>
            <a className={styles.featuredLink} href="/services">Meet your digital toolkit <span aria-hidden="true">↗</span></a>
          </article>
        )}
        <div className={styles.grid}>
          {items.map((item) => (
            <article key={item.title} className={styles.item}>
              <div className={styles.icon}><WhyIcon name={item.icon} /></div>
              <h3 className={styles.title}>{item.title}</h3>
              <p className={styles.text}>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </Section>
  );
}
